import { useState } from "react";
import CompanySelect from "../../components/CompanySelect";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import Swal from "sweetalert2";
import { userRequesIntegration } from "../../requestMethods";
import Loading from "../../components/loading/loading";
export default function Integration() {
  const [companyId, setCompanyId] = useState();
  const [id, setId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const handleChange = (e) => {
    setId(e.target.value);
  };
  const atualizarTiny = async () => {
    setIsLoading(true);
    try {
      const res = await userRequesIntegration.post(
        `${companyId}/tiny/atualizarproduto`,
        [id]
      );

      if (Object.keys(res.data).length > 0) {
        setIsLoading(false);
        Swal.fire("Parabéns!", "Atualizado com sucesso!", "success");
      }
    } catch (e) {
      setIsLoading(false);
    }
  };
  const atualizarBling = async () => {
    setIsLoading(true);
    try {
      const res = await userRequesIntegration.post(
        `${companyId}/bling/atualizarproduto`,
        [id]
      );

      if (Object.keys(res.data).length > 0) {
        setIsLoading(false);
        Swal.fire("Parabéns!", "Atualizado com sucesso!", "success");
      }
    } catch (e) {
      setIsLoading(false);
    }
  };
  return (
    <div className="div_custom_">
      {isLoading ? (
        <Loading />
      ) : (
        <div className="div_custom_Container">
          <CompanySelect onSelect={(companyId) => setCompanyId(companyId)} />
          <div className="div_custom_UpdateItem">
            <label>Integração</label>
          </div>
          <div className="div_custom_UpdateItem">
            <label className="custom_label">Id produto:</label>
            <input
              type="text"
              name="subcategory"
              onChange={handleChange}
              maxLength="100"
            />
            <div>
              <Button
                variant="outlined"
                color="secondary"
                className="custom_mui_action"
                startIcon={<SaveIcon />}
                onClick={atualizarTiny}
              >
                Tiny Atualizar Produto
              </Button>
            </div>
            <div>
              <Button
                variant="outlined"
                color="secondary"
                className="custom_mui_action"
                startIcon={<SaveIcon />}
                onClick={atualizarBling}
              >
                Bling Atualizar Produto
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
